import breakpoints from '../../theme/breakpoints'

import css from 'styled-jsx/css'

export default css.div`
  .radar-map-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin: 20px 0;
  }

  .map {
    height: 480px;
  }
  
  @media only screen and (max-width: ${breakpoints.lg}px) {
    .radar-map-container {
      box-size: border-box;
    }
  }
`
